export const DEMO_QUESTION_LIMIT = 10;
export const DEMO_PURCHASE_URL = 'https://medexam.app/produkt/pruefungsfragen/';
export const DEMO_PURCHASE_URL_EN = 'https://medexam.app/en/product/exam-questions/';
export const DEMO_SESSION_STORAGE_KEY = 'medexam.demo.session';
export const DEMO_OPTION_COUNT = 5;

export function demoPurchaseUrl(lang: string | null | undefined): string {
  return lang === 'de' ? DEMO_PURCHASE_URL : DEMO_PURCHASE_URL_EN;
}
